import { render, staticRenderFns } from "./helloTongCard.vue?vue&type=template&id=1e526c0f&scoped=true"
import script from "./helloTongCard.vue?vue&type=script&lang=ts"
export * from "./helloTongCard.vue?vue&type=script&lang=ts"
import style0 from "./helloTongCard.vue?vue&type=style&index=0&id=1e526c0f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e526c0f",
  null
  
)

export default component.exports